// PGE Multi Vendor Prevention — sort line types by date instead of size
export const PGE_MULTI_VENDOR_PREVENTION_TOOLBOX_ID = 'PE2ldc9vXr_iI58RA4wc';
export const PGE_SORT_LINE_DATE_CUTOFF = '2026-05-21T00:00:00.000Z';

export const TOOLKIT_DISABLE_MODIFY_FLAG = 'Disable Toolkit Modifications';
export const TOOLKIT_DISABLE_EXPORTS_FLAG = 'Disable Data Exports';

export const FILE_TOOL_GROUP_NAME = 'Files';


export const LINK_TOOLS = {
    video: true,
    file: true,
    image: true,
    audio: true
};

export const FILEPICKER_DESCRIPTION_CONTROL_LABEL = 'Description';

